<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Halaman tidak ditemukan',
    meta: [
      { name: 'description', content: 'The page timed out while loading.' },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="account-pages my-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3 class="mt-3">404</h3>
            <p class="text-muted mb-5">
              Maaf, halaman yang anda tuju tidak ditemukan atau sudah berpindah.
            </p>
          </div>
        </div>
      </div>
      <!-- end container -->
    </div>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>

